import { Injector, Type } from '@angular/core';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { MenuButton } from 'src/app/shared/model/menu-button';

@Injectable({
  providedIn: 'root'
})
export class SideBarService {

  private configSub = new BehaviorSubject<SideBarConfig>(null);

  constructor(private router: Router) { }

  dataSub$ = combineLatest([
    this.configSub.asObservable(),
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      startWith(null),
      map(() => this.router.url.split('?')[0])
    )
  ]).pipe(
    map(([config, url]) => ({
        isVisible: config != null && !isEmpty(config.menuButtons) && !config?.ignores?.some(path => url === path || url.endsWith(path)),
        activeButton: config?.menuButtons?.find(btn =>
          btn.routerLink === url || btn.routerLink === url + '/' || url.startsWith(btn.routerLink + '/')
        ),
        config
      })
    ),
    distinctUntilChanged((a, b) => a.isVisible === b.isVisible && a.config === b.config && a.activeButton === b.activeButton)
  );

  setConfig(config: SideBarConfig): void {
    this.configSub.next(config);
  }

  clearConfig(): void {
    this.configSub.next(null);
  }

}

export class SideBarConfig {
  parentPath: string;
  // Side bar jest poza modułem, więc ścieżki w przyciskach muszą być pełne.
  menuButtons: MenuButton[];
  injectionConfig?: {
    headerComponents: { component: Type<any>; inputs?: Record<string, any> }[];
    footerComponents: { component: Type<any>; inputs?: Record<string, any> }[];
    injector?: Injector;
  };
  // Ścieżki w module, w których nie ma być widoczny side bar.
  ignores?: string[];
}
